<template>
  <div>
    <div
      class="flex h-full fixed top-0 left-0 pointer-events-none outline-none w-full"
      :class="{ 'pointer-events-auto': active }"
      :style="{ zIndex: zIndexContent }"
      @mousedown="mouseDownActive"
      ref="OffCanvasContent"
    >
      <transition :name="animations" appear>
        <div
          v-if="active"
          class="zt-off-canvas bg-white w-full lg:w-auto absolute"
          :class="[isPosition]"
          :style="{ width }"
        >
          <button
            v-if="showButtonClose"
            class="focus:outline-none zt-off-canvas-button-close p-1 flex items-center justify-center absolute cursor-pointer rounded-full hover:text-zt-primary-200"
            @click.stop="$emit('close')"
          >
            <zt-icon class="" name="times" />
          </button>
          <div class="offcanvas-body">
            <slot/>
          </div>
        </div>
      </transition>
    </div>
    <zt-overlay :z-index="zIndex" :active="active" />
  </div>
</template>

<script>
export default {
  name: 'ztOffCanvas',
  props: {
    active: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: 'left'
    },
    showButtonClose: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: '500px'
    },
    zIndex: {
      type: Number,
      default: 20
    }
  },
  mounted() {
    document.addEventListener('keydown', this.escapeHandler)
  },
  computed: {
    zIndexContent() {
      return this.zIndex + 1
    },
    width() {
      if (this.fullscreen) {
        return '100%'
      }
      return this.maxWidth
    },
    animations() {
      const types = {
        'left': 'animate-left',
        'right': 'animate-right',
      }
      return types[this.position]
    },
    isPosition() {
      if (this.position === 'right') {
        return 'zt-off-canvas-right right-0'
      }
      return 'zt-off-canvas-left left-0'
    }
  },
  watch: {
    active: function() {
      document.body.style.overflow = this.active ? 'hidden' : ''
    }
  },
  methods: {
    mouseDownActive(event) {
      if (this.$refs.OffCanvasContent === event.target) {
        this.$emit('close')
        event.preventDefault()
      }
    },
    escapeHandler(e) {
      if (e.key === 'Escape' && this.active) {
        this.$emit('close')
      }
    }
  },
  destroyed() {
    document.removeEventListener('keydown', this.escapeHandler)
  }
}
</script>

<style
  scoped
  lang="css"
  src="../../../../../src/styles/components/ztOffCanvas.css"
></style>
